/***

	List of customers or suppliers (this.props.list)
	Refresh enabled pull-down.
	To add card layout

****/

import * as React from 'react';
import { Dimensions, RefreshControl, Platform, StyleSheet, Keyboard, ScrollView } from 'react-native';
import { Container, Header, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem, Spinner, InputGroup, Input, Item, View } from 'native-base';
import PopupMenu from './popupMenu';

class PeopleList extends React.Component<Props, State> {
	constructor(props) {
		super(props);
		const { width, height } = Dimensions.get('window');
		this.state = {
			searching: false,
			height: width <= 860 ? height - 160 : height - 100
		};
	}

	handleResize = () => {
		const { width, height } = Dimensions.get('window');
		this.setState({ height: width <= 860 ? height - 160 : height - 100 });
	};

	componentDidMount() {
		// Hacky fix for fixing list height?
		if (Platform.OS === 'web') {
			window.addEventListener('resize', this.handleResize);
			this.keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', this.handleResize);
			this.keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', this.handleResize);
		}
	}

	componentWillUnmount() {
		this.keyboardDidShowListener && this.keyboardDidShowListener.remove();
		this.keyboardDidHideListener && this.keyboardDidHideListener.remove();
		Platform.OS == 'web' && window && window.removeEventListener('resize', this.handleResize);
	}

	render() {
		return (
			<Container style={{ backgroundColor: '#FBFAFA', flexBasis: this.state.height }}>
				<ScrollView
					style={{ height: '100%' }}
					refreshControl={
						<RefreshControl
							refreshing={this.props.refreshing}
							onRefresh={() => {
								this.props.doRefresh();
							}}
						/>
					}>
					<List>
						{this.props.list.map((item, i) => (
							<ListItem
								avatar
								key={i}
								onPress={() => {
									this.props.onSelectCustomer(item);
								}}
								style={{ alignItems: 'stretch' }}>
								<Left style={{ alignSelf: 'center' }}>
									<Icon
										name={item.personType == 'customer' ? 'contact' : 'cart'}
										style={{ fontSize: 26, width: 26, color: (item.owes && item.owes > 0) || (item.owed && item.owed > 0) ? '#b30000' : '#29a329' }}
									/>
								</Left>
								<Body style={{ marginLeft: 7 }}>
									<Text>{item.display}</Text>
									<Text note>
										{item.businessName ? item.name : ''} {item.notes}
									</Text>
								</Body>

								{item.personType == 'customer' ? (
									<Right>
										<Text note>Owes</Text>
										<Text>£{item.owes}</Text>
									</Right>
								) : (
									<Right>
										<Text note>You owe</Text>
										<Text>£{item.owed}</Text>
									</Right>
								)}
							</ListItem>
						))}
					</List>
				</ScrollView>
			</Container>
		);
	}
}

export default PeopleList;

const styles = StyleSheet.create({
	container: {},
	row: {
		flex: 1,
		alignItems: 'center'
	},
	text: {
		fontSize: 20,
		marginBottom: 15,
		alignItems: 'center'
	},
	mt: {
		marginTop: 18
	},

	modalStyle: {
		borderRadius: 10,
		width: '90%',
		height: '95%'
	},
	modalContainer: {
		flex: 1,
		//justifyContent: 'center',
		backgroundColor: '#f8f8fc'
	},
	innerContainer: {
		flex: 1
		//alignItems: 'center',
	},
	modalHeader: {
		height: 45,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	}
});
